import { ButtonGroup, Button } from "@progress/kendo-react-buttons";
import { AppList, AuthList, CafmButtonGroup, CafmListView, CafmMenu, CompanySelector, DefaultRoomBookingSearchList, DefaultWorkOrderOrderSearchList, HistoryList, SavedSearchList } from "./cafm.widgets.jsx";
import { Util } from "../core/cafm.util.jsx";

export class HeaderContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (isMobile) {
            if (this.props.isAuthenticated) {

                $("<span class=\"caret-down\"></span>").appendTo($(".site-logo"));
                let cta = $(".module-menu").appendTo("#mobileMenu").find(".call-to-action");
                $("#headerCentre").remove();
                if (cta.length) {
                    let ctaimg = cta.find("img"), ctatxt = ctaimg.attr("alt");
                    if (ctatxt) {
                        cta.text(ctatxt);
                        cta.prepend(ctaimg);
                    }
                }
                $("#header-container").on("click", "a, button", function (e) {

                    switch (e.currentTarget.id) {
                        case "site-logo":
                            $('#mobileMenu').toggle();
                            $('.cFilterSet,.mobileListMenu').hide();
                            e.preventDefault();
                            break;
                        case "backBtn":
                            var k = 'cafm.back';
                            if (cafm.handlers.exists(k)) {
                                cafm.handlers.exe(k, e);
                            }
                            else {
                                cafm.url.set(); // go to default/home page
                            }
                            e.preventDefault();
                            break;
                    }
                });

                $('#mobileUserMenuButton').click(cafm.web.handlers.userMenuBtnHandle);
            }
        }
    }

    setSiteHeaderText(txt) {

        var sll = $('#site-logo');

        if (txt) {
            sll.text(txt);
            sll.addClass('site-logo-text');
        }
        else {
            sll.text('');
            if (!isMobile) sll.removeClass('site-logo-text');
        }

        $("<span class=\"caret-down\"></span>").appendTo($(".site-logo"));
    }

    render() {
        let hCentre = cafm.util.hasItem(cafm.util.getReference('moduleMenu.items', this.props)) ? <HeaderCentre {...this.props} /> : null;
        let hRight = !isMobile && this.props.isAuthenticated ? <HeaderRight {...this.props} /> : null;  

        return (
            <div id="header-container" className="layout-container">
                <HeaderLogo {...this.props} />
                {hCentre}
                {hRight}
            </div>
        );
    }
}
class HeaderLogo extends React.Component {
    render() {
        let appList = this.props.appList ? <AppList options={this.props.appList} /> : null;
        let logoCssClass = this.props.siteHeaderTitle != null ? "site-logo site-logo-text" : "site-logo";
        let divClass = 'site-logo site-logo-div';
        let title = this.props.siteHeaderTitle;
        let timeZoneName = cafm.cache.session.get(cafm.res.consts.CacheKey_TimeZone);
        const renderMobileTZ = () => {
            if (isMobile) {
                return <span className="session-time-zone-mobile" title={timeZoneName}>{timeZoneName}</span>
            }
        } 

        if (!title && isMobile) {
            title = cafm.res.str.TitleCafmWeb;
        }
        if (appList) {
            return (
                <div id="site-logo" className={logoCssClass}>{title}{appList}</div>
            );
        }
        else {
            return (
                <div className={divClass}>
                    <a id="site-logo" className={logoCssClass} href="/">{title}</a>
                    {renderMobileTZ()}
                </div>
            );
        }
    }
}

class HeaderCentre extends React.Component {

    setupModuleMenu() {

        if (!isMobile) {

            let me = this;
            cafm.util.callFunctionAsync({
                func: function () {

                    let element = ReactDOM.findDOMNode(me);
                    let moduleMenu = $(element).find(".module-menu .k-menu");

                    if (!(moduleMenu || moduleMenu.length)) {

                        return;
                    }

                    let otherItems = moduleMenu.find('.other-menu-item'),
                        widget = moduleMenu.getKendoMenu();

                    let callToAction = moduleMenu.find(".call-to-action");
                    if (callToAction.length) {
                        callToAction = callToAction.parent().addClass("call-to-action");
                    }

                    if (!otherItems.length) {

                        otherItems = $('<li/>', {

                            'class': 'k-item other-menu-item',
                            html: '<a href="{0}" class="k-link" onclick="return false;">{1}</a>'.format(cafm.url.get(), 'More')
                        });

                        if (!callToAction.length) {

                            widget.append(otherItems);
                        }
                        else {

                            widget.insertBefore(otherItems, callToAction);
                        }
                    }

                    let ensureMenuFits = function (widget) {

                        // start by hiding other apps item
                        otherItems.hide();

                        let appMenuHeight,
                            containerHeight,
                            setHeightVars = (function () {

                                appMenuHeight = $(".module-menu .k-menu").outerHeight();
                                containerHeight = $('#siteHeader').outerHeight();
                            }),
                            moveItemToOtherApps = function () {

                                var moveApp = widget.element.find("> :not(.other-menu-item, .call-to-action)").last();

                                if (otherItems.find('.k-item').length) {

                                    widget.insertBefore(moveApp, otherItems.find('.k-item').first());
                                }
                                else {

                                    widget.append(moveApp, otherItems);
                                }
                            };

                        // set height vars
                        setHeightVars();

                        let i = 0;
                        // check if menu fits
                        while (appMenuHeight > containerHeight) {

                            i++;

                            // move item into other apps
                            moveItemToOtherApps();

                            // set height vars
                            setHeightVars();

                            if (i > 200) {

                                console.error('Error setting up ButtonGroup overflow menu: too many attempts to fit.');
                                break;
                            }
                        }

                        if (otherItems.find('li').length > 0) {

                            // show all apps
                            otherItems.show();

                            // now do 1 last time to ensure all apps fits
                            setHeightVars();

                            if (appMenuHeight > containerHeight) {

                                moveItemToOtherApps();
                            }
                        }
                    }

                    // ensure apps fit
                    ensureMenuFits(widget);

                    $(window).resize(function () {

                        // move other apps back to top level
                        widget.insertBefore($(".module-menu .k-menu").find(".other-menu-item .k-item"), otherItems);

                        // ensure apps fit
                        ensureMenuFits(widget);
                    });
                }, timeout: 100
            });
        }
    }

    render() {
        this.setupModuleMenu();
        return (
            <div id="headerCentre">
                <CafmMenu options={this.props.moduleMenu} />
            </div>
        );
    }
}

class HeaderRight extends React.Component {
    newSearch() {
        cafm.url.hash('newSearch/' + cafm.guid.newGuid());
    }

    render() {
        let searchElement;
        let savedSearchList = this.props.savedSearchOptions ? <SavedSearchList options={this.props.savedSearchOptions} /> : null;
        let historyList = this.props.historyOptions ? <HistoryList options={this.props.historyOptions} /> : null;
        let authList = this.props.authList ? <AuthList options={this.props.authList} /> : null;
        let companiesList = this.props.userCompanies ? <CompanySelector options = { this.props.userCompanies }/> : null;

        let sessionTimeZone;
        let timeZoneName = cafm.cache.session.get(cafm.res.consts.CacheKey_TimeZone);
        if (savedSearchList) window.SavedSearchList = savedSearchList;
        if (historyList) window.HistoryList = historyList;
        if (timeZoneName) {
            sessionTimeZone = <div className="session-time-zone"><span title={timeZoneName}>{timeZoneName}</span></div>;
        }
        if (this.props.searchOptions && this.props.searchOptions.quickSearchEnabled) {
            searchElement = <div className="search-box">
                <input id="searchText" type="text" placeholder="Enter search" maxLength="50" required />
                {this.props.searchOptions.isNewSearchEnabled === true ? <button className="new-search" title={cafm.res.str.LabelNewSearch} onClick={this.newSearch}></button> : null}
            </div>;
        }
        else if (this.props.searchOptions && this.props.searchOptions.isNewSearchEnabled) {
            searchElement = <button className="new-search-btn" title={cafm.res.str.LabelNewSearch} onClick={this.newSearch}>
                <span className="caret-down"></span>
            </button>;
        }
        else {
            searchElement = null;
        }
        return (
            <div id="headerRight">
                {sessionTimeZone}
                <CafmMenu options={this.props.userMenu} />
                {companiesList}
                {searchElement}
                {authList}
                {savedSearchList}
                {historyList}
            </div>
        );
    }
}

export class SubHeaderContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = props;
    }

    refresh(p) {
        this.setState(p);
    }

    setToolbar(refreshedToolbar) {

        this.setState((prevState, props) => {
            return {
                showSubHeader: prevState.showSubHeader,
                toolbar: refreshedToolbar,
                toolbar2: prevState.toolbar2,
                title: prevState.title
            }
        });
        cafm.toolbar.helpers.ensureToolbarDisplay();
    }

    render() {

        if (this.state && this.state.showSubHeader == cafm.enums.LayoutElementVisibility.Visible) {

            let tbar = this.state.toolbar ? <div id="sub-header-toolbar"><CafmButtonGroup options={this.state.toolbar} /></div> : null;
            let tbarTwo = this.state.toolbar2 ? <CafmButtonGroup options={this.state.toolbar2} /> : null;
            let title = this.state.title;
            let titleElement;
            $('#' + cafm.res.consts.ElementId_SubHeader).show();

            if (isMobile) {
                if (title) {
                    window.HeaderContainer.setSiteHeaderText(title);
                }
                titleElement = null;
            }
            else if (title) {
                titleElement = <h1>{title}</h1>;
            }
            if (!isMobile || ((this.state.toolbar && Util.hasItem(this.state.toolbar.items)) || (this.state.toolbar2 && Util.hasItem(this.state.toolbar2.items)))) {
                return (
                    <div className="layout-container">
                        {titleElement}
                        {tbarTwo}
                        {tbar}
                    </div>
                );
            }
        }
        $('#' + cafm.res.consts.ElementId_SubHeader).hide();
        return (
            <div className="layout-container"></div>
        );
    }
}

export class DashboardLayout extends React.Component {

    constructor(props) {
        super(props);
        let me = this,
            newWoId = cafm.res.consts.Var_DashboardNewWorkOrderTileID.toLowerCase(),
            swoNoGroupId = cafm.res.consts.Var_DashboardStandardWorkOrderNoGroupID.toLowerCase(),
            scanCodeId = cafm.res.consts.Var_DashboardScanCodeTileID.toLowerCase();

        cafm.dash = {
            fitTabbedContent: function (element) {

                if (!element.find('.wo-item').length) return;
                element.closest(".k-content").children().css("visibility", "hidden");
                cafm.util.callFunctionAsync({
                    func: function () {
                        me.fitTabbedContent(element);
                        element.closest(".k-content").children().hide();
                        element.closest(".k-content").children().css("visibility", "visible");
                        element.closest(".k-content").children().fadeIn();
                    },
                    key: "cafm.dash.fitTabbedContent.{0}".format(element.attr("id")),
                    timeout: 300
                });
            },
            isNewWoTile: function (swoc) {
                return swoc.ID.toLowerCase() == newWoId;
            },
            isNoGroupSwo: function (swoc) {
                return swoc.ID.toLowerCase() == swoNoGroupId;
            },
            isThereAreSwoWithNoGroup: function () {
                var swogt = props.swogListTree[props.swogListTree.length - 1];
                return Object.values(swogt)[0].length > 0;
            },
            showNewWorkOrderButton: function () {
                return props.showNewWorkOrderButton;
            },
            getStandardWorkOrderGroupTree: function (id, target) {
                var swogts = props.swogListTree;
                var swogt;

                for (var i = 0; i < swogts.length; i++) {
                    if (Object.keys(swogts[i])[0] == id) {
                        swogt = swogts[i];
                        break;
                    }
                }

                var targetLink = "_self";
                if (target != null)
                    targetLink = target;

                var html = "";

                for (var i = 0; i < Object.values(swogt)[0].length; i++) {
                    if (Object.values(swogt)[0][i] != undefined) {
                        if (Object.values(swogt)[0][i].CanHaveChildren) {
                            html = html + '<li class="dropdown-submenu"><a class="swogDrill" data-id="' + Object.values(swogt)[0][i].ID + '" target="' + targetLink + '" tabIndex="-1" >' + Object.values(swogt)[0][i].Description + '<span class="list-chevron"></span></a></li>';
                        } else {
                            var url = cafm.url.get("helpdesk#newSwoWorkOrder/" + Object.values(swogt)[0][i].ID);
                            html = html + '<li><a tabIndex="-1" href="' + url + '" target="' + targetLink + '">' + Object.values(swogt)[0][i].Description + '</a></li>';
                        }
                    }
                }

                return html;
            },
            isScanTile: function (sho) {
                return sho.ID.toLowerCase() == scanCodeId;
            },
            shortcutDataBound: function (args) {

                let scanCodeId = cafm.res.consts.Var_DashboardScanCodeTileID.toLowerCase();
                args.sender.element.find(".shortcut").each((i, el) => {

                    let link = $(el);
                    if (link.data("id").toLowerCase() == scanCodeId) {
                        link.addClass("scan-barcode-tile");
                        link.click(cafm.scanner.open);
                    }
                });
            }
        }
    }

    componentDidMount() {
        this.setup();
    }

    setup() {

        $("#horizontal").kendoSplitter({
            panes: [
                { collapsible: false, size: "25%", scrollable: false },
                { collapsible: false, size: "75%", scrollable: false }
            ]
        });

        $("#tabstrip").height($("#left-pane").height()).kendoTabStrip({
            animation: false,
            select: function (e) {
                cafm.dash.fitTabbedContent($(e.contentElement).find(".k-listview"));
            }
        }).getKendoTabStrip().select("li:first");

        $(window).on("resize.cafmdash", function () {

            if (cafm.dash.fitTabbedContentTimeout) clearTimeout(cafm.dash.fitTabbedContentTimeout);
            cafm.dash.fitTabbedContentTimeout = setTimeout(function () {
                $("#tabstrip").height($("#left-pane").height());
                cafm.dash.fitTabbedContent($("#tabstrip .k-listview:visible"));
            }, 100);
        });

        $("#panelbar").kendoPanelBar({
            expandMode: "multiple"
        });
    }

    fitTabbedContent(element) {

        if (!element.length) {
            console.error("fitTabbedContent: element not found.");
            return;
        }

        let tabstrip = element.closest('.k-tabstrip'),
            items = element.find('.wo-item');

        if (!items.length) return;

        items.show();
        let i = 0;
        let tabContentSpace = tabstrip.outerHeight() - tabstrip.find(".k-tabstrip-items").outerHeight();
        let viewAllHeight = element.closest(".k-content").find(".view-all").outerHeight();
        while (tabContentSpace < (element.outerHeight() + viewAllHeight)) {
            console.info("fitTabbedContent: tabstrip height:{0}, element height:{1}".format(tabContentSpace, element.outerHeight() + viewAllHeight));
            i++;
            items.filter(":visible").last().hide();

            if (i > items.length) {
                items.show();
                console.error("fitTabbedContent: failed to fit content for element {0}.".format(element.attr("id")));
                break;
            }
        }
    }

    listDataBound(args) {
        cafm.dash.fitTabbedContent(args.sender.element);
    }

    render() {
        let historyList = this.props.historyList;
        historyList.ClientId = "historyView";
        historyList.HtmlTagName = "div";

        let appList = this.props.appList;
        appList.ClientId = "dash-app-list";
        appList.HtmlTagName = "div";

        // remove the default page menu item (this dashboard)
        cafm.util.removeWhere(appList.DataSourceData, function (item) { return item.url == cafm.url.get() });

        let swogElement;
        if (this.props.swogList) {
            let swogList = this.props.swogList;
            swogList.HtmlTagName = "div";
            swogElement = <li className="k-state-active">
                <span className="k-link k-state-selected">{swogList.title}</span>
                <script type="text/x-kendo-template" id={swogList.ClientId + "-item-template"}>
                    # if(cafm.dash.isNewWoTile(data)) {"{"} #
                        # if(cafm.dash.showNewWorkOrderButton()) {"{"} #
                            <a className="dash-item swo k-link new-wo-tile swog-img" href="#: cafm.url.get('helpdesk\#newworkorder')#" target="_self" title="#:data.Tooltip ? Tooltip : Description#">
                        <span className="dash-icon log-wo-icon"></span>
                        <div className="details">
                            <h2>#:Description || ''#</h2>
                        </div>
                    </a>
                    # {"}"} #
                    # {"}"} else {"{"} #
                        # if(cafm.dash.isNoGroupSwo(data)) {"{"} #
                            # if(cafm.dash.isThereAreSwoWithNoGroup()) {"{"} #
                                <div className="dropdown">
                        <a className="dash-item swo k-link swog-img" title="#:data.Tooltip ? Tooltip : Description#">
                            <span className="no-group-icon"></span>
                            <div className="details">
                                <h2>#:Description || ''#</h2>
                            </div>
                        </a>
                        <div className="dropdown-content dropdown-position">
                            <ul className="dropdown-menu" data-level="0">
                                # var html = cafm.dash.getStandardWorkOrderGroupTree(data.ID, null); #
                                #= html #
                                        </ul>
                        </div>
                    </div>
                    # {"}"} #
                        # {"}"} else {"{"} #
                            <div className="dropdown">
                        <a className="dash-item swo k-link swog-img" title="#:data.Tooltip ? Tooltip : Description#">
                            <img className="dash-img" src={"#:cafm.util.getReference('Image.FileURL', data) ? Image.FileURL : cafm.url.get('content/themes/default/images/default-tile.jpg')#"} alt="#:Description#" />
                            <div className="details">
                                <h2>#:Description || ''#</h2>
                            </div>
                        </a>
                        <div className="dropdown-content dropdown-position">
                            <ul className="dropdown-menu" data-level="0">
                                # var html = cafm.dash.getStandardWorkOrderGroupTree(data.StandardWorkOrderGroupID, data.Target); #
                                #= html #
                                    </ul>
                        </div>
                    </div>
                    # {"}"} #
                    # {"}"} #
                </script>
                <CafmListView options={swogList} />
            </li>;
        }

        $(document).ready(function () {

            $("body").on("click", ".swog-img", function (e) {

                if ($(this).next(".dropdown-content").hasClass("show")) {
                    $(this).next(".dropdown-content").removeClass("show")
                } else {
                    var dropdowns = $('.dropdown-content');

                    for (var i = 0; i < dropdowns.length; i++) {
                        if ($(dropdowns[i]).hasClass('show')) {
                            $(dropdowns[i]).removeClass('show');
                        }
                    }

                    DropdownClosing(0);

                    $(this).next(".dropdown-content").addClass("show");

                    $("#panelbar").css("height", "");
                    var height = $(this).closest("ul")[0].scrollHeight;
                    $("#panelbar").css("height", height);
                }
            });

            $("body").on("click", ".swogDrill", function (e) {

                var element = $(this);
                var id = $(this).attr("data-id");
                var target = $(this).attr("target")
                var dataElement = $(this).attr("data-element");

                if (dataElement == null || dataElement == undefined) {
                    cafm.actions.execute({
                        url: cafm.url.api("StandardWorkOrder/GetStandardWorkOrderGroupTree?standardWorkOrderGroupId=" + id),
                        sync: true,
                        statusCodeFuncs: {
                            200: function (response) {
                                var html = "";

                                for (var i = 0; i < response.length; i++) {
                                    if (response[i] != undefined) {
                                        if (response[i].CanHaveChildren) {
                                            html = html + '<li class="dropdown-submenu"><a class="swogDrill" data-id="' + response[i].ID + '" target="' + target + '" tabIndex="-1" >' + response[i].Description + '<span class="list-chevron"></span></a></li>';
                                        } else {
                                            var url = cafm.url.get("helpdesk#newSwoWorkOrder/" + response[i].ID);
                                            html = html + '<li><a tabIndex="-1" href="' + url + '" target="' + target + '">' + response[i].Description + '</a></li>';
                                        }
                                    }
                                }

                                var level = $(element).closest("ul").attr("data-level");
                                level = parseInt(level) + 1;
                                $(element).after('<ul class="dropdown-sub-submenu show" style="right: 0px" data-level="' + level + '">' + html + '</ul>');
                                $(element).attr("data-element", "true");
                            }
                        }
                    });
                }

                var dropdownLevel = $(element).closest('ul').attr("data-level");
                dropdownLevel = parseInt(dropdownLevel);

                DropdownClosing(dropdownLevel);

                $(element).next(".dropdown-sub-submenu").addClass("show");
                $("#panelbar").animate({ scrollLeft: 1000 }, 1000);
            });

            function DropdownClosing(dropdownLevel) {
                var dropdowns = $('.dropdown-sub-submenu');
                for (var i = 0; i < dropdowns.length; i++) {
                    var level = $(dropdowns[i]).closest('ul').attr("data-level");
                    level = parseInt(level);
                    if (level > dropdownLevel) {
                        if ($(dropdowns[i]).hasClass('show')) {
                            $(dropdowns[i]).removeClass('show');
                        }
                    }
                }
            }
        });

        let swoElement;
        if (this.props.swoList) {
            let swoList = this.props.swoList;
            swoList.HtmlTagName = "div";
            swoElement = <li className="k-state-active">
                <span className="k-link k-state-selected">{swoList.title}</span>
                <script type="text/x-kendo-template" id={swoList.ClientId + "-item-template"}>
                    # if(cafm.dash.isNewWoTile(data)) {"{"} #
                        # if(cafm.dash.showNewWorkOrderButton()) {"{"} #
                            <a className="dash-item swo k-link new-wo-tile" href="#: cafm.url.get('helpdesk\#newworkorder')#" target="_self" title="#:data.Tooltip ? Tooltip : Description#">
                        <span className="dash-icon log-wo-icon"></span>
                        <div className="details">
                            <h2>#:Description || ''#</h2>
                        </div>
                    </a>
                    # {"}"} #
                    # {"}"} else {"{"} #
                    <a className="dash-item swo k-link#: cafm.dash.isNewWoTile(data) ? ' new-wo-tile' : ''#" href="#: cafm.dash.isNewWoTile(data) ? cafm.url.get('helpdesk\#newworkorder') : cafm.url.get('helpdesk\#newSwoWorkOrder/{0}', StandardWorkOrderID)#" target="#: cafm.dash.isNewWoTile(data) ? '_self' : (data.Target ? Target : '_self') #" title="#:data.Tooltip ? Tooltip : Description#">
                        # if(cafm.dash.isNewWoTile(data)) {"{"} #
                                    <span className="dash-icon log-wo-icon"></span>
                        # {"}"} else {"{"} #
                                    <img className="dash-img" src={"#:cafm.util.getReference('Image.FileURL', data) ? Image.FileURL : cafm.url.get('content/themes/default/images/default-tile.jpg')#"} alt="#:Description#" />
                        # {"}"} #
                                    <div className="details">
                            <h2>#:Description || ''#</h2>
                        </div>
                    </a>
                    # {"}"} #
                </script>
                <CafmListView options={swoList} />
            </li>;
        }

        let shortcutElement;
        if (this.props.shortcutList) {
            let shortcutList = this.props.shortcutList;
            shortcutList.HtmlTagName = "div";
            shortcutList.OnDataBound = cafm.dash.shortcutDataBound;
            shortcutElement = <li className="k-state-active">
                <span className="k-link k-state-selected">{shortcutList.title}</span>
                <script type="text/x-kendo-template" id={shortcutList.ClientId + "-item-template"}>
                    <a className="dash-item shortcut k-link" href="#:URL#" target="#:data.Target ? Target : '_self'#" title="#:data.Tooltip ? Tooltip : Text#" data-id="#:ID#">
                        # if(cafm.dash.isScanTile(data)) {"{"} #
                                        <span className="dash-icon scan-barcode-icon"></span>
                        # {"}"} else {"{"} #
                                        <img className="dash-img" src={"#:cafm.util.getReference('Image.FileURL', data) ? Image.FileURL : cafm.url.get('content/themes/default/images/default-tile.jpg')#"} alt="#:Text#" />
                        # {"}"} #
                                        <div className="details">
                            <h2>#:Text#</h2>
                        </div>
                    </a>
                </script>
                <CafmListView options={shortcutList} />
            </li>;
        }

        if (this.props.roomBookingSearchList) {
            this.props.roomBookingSearchList.OnDataBound = this.listDataBound;
        }

        let roomBookingList = this.props.roomBookingSearchList ? <DefaultRoomBookingSearchList options={this.props.roomBookingSearchList} /> : null;
        let roomBookingTab = this.props.roomBookingSearchList ? <li>{this.props.roomBookingSearchList.title}</li> : null;

        if (this.props.workOrderSearchList) {
            this.props.workOrderSearchList.OnDataBound = this.listDataBound;
        }

        let workOrderList = this.props.workOrderSearchList ? <DefaultWorkOrderOrderSearchList options={this.props.workOrderSearchList} /> : null;
        let workOrderTab = this.props.workOrderSearchList ? <li>{this.props.workOrderSearchList.title}</li> : null

        return (
            <div id="horizontal">
                <div id="left-pane">
                    <div className="pane-content">
                        <div id="tabstrip">
                            <ul>
                                {workOrderTab}
                                {roomBookingTab}
                                <li>{cafm.res.str.TitleHistoryWidget}</li>
                            </ul>
                            {workOrderList}
                            {roomBookingList}
                            <div>
                                <script type="text/x-kendo-template" id={historyList.ClientId + "-item-template"}>
                                    <a className="wo-item k-link" href="#:navUrl#" title="#: cafm.res.str.TemplateView0.format(itemTitle) #">
                                        <div className="wo-icon #:data.itemType ? cafm.enums.getEnumKey(cafm.enums.HistoryItemType, itemType).toLowerCase() : ''#"></div>
                                        <div className="wo-body">
                                            <h3 className="wo-title">#:itemTitle#</h3>
                                            <span className="list-chevron"></span>
                                            <p className="desc" title="#:data.itemDetail#">#:data.itemDetail ? cafm.util.reduceString(itemDetail, 50, "...") : ""#</p>
                                        </div>
                                    </a>
                                </script>
                                <CafmListView key="historyList" options={historyList} />
                            </div>
                        </div>
                    </div>
                </div>
                <div id="right-pane">
                    <div className="pane-content">
                        <ul id="panelbar">
                            {swogElement}
                            {swoElement}
                            {shortcutElement}
                            <li className="k-state-active">
                                <span className="k-link k-state-selected">Apps</span>
                                <div>
                                    <script type="text/x-kendo-template" id={appList.ClientId + "-item-template"}>
                                        <a className="dash-item k-link" href="#:url#" target="#:data.Target ? Target : '_self'#">
                                            <div className="app-icon #:spriteCssClass#"></div>
                                            <div className="details">
                                                <h2>#:text#</h2>
                                            </div>
                                        </a>
                                    </script>
                                    <CafmListView key="appList" options={appList} />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}